import { render, staticRenderFns } from "./repair-handling.vue?vue&type=template&id=94d9d3a4&"
import script from "./repair-handling.vue?vue&type=script&lang=js&"
export * from "./repair-handling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports